import { render, staticRenderFns } from "./ProductLoft.vue?vue&type=template&id=0d00b962&scoped=true&"
import script from "./ProductLoft.vue?vue&type=script&lang=js&"
export * from "./ProductLoft.vue?vue&type=script&lang=js&"
import style0 from "./ProductLoft.vue?vue&type=style&index=0&id=0d00b962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00b962",
  null
  
)

export default component.exports